export default "__VITE_ASSET__IXmACY5e__"